import { render } from "./qualificationManage.vue?vue&type=template&id=a78134de&scoped=true"
import script from "./qualificationManage.vue?vue&type=script&lang=js"
export * from "./qualificationManage.vue?vue&type=script&lang=js"

import "./qualificationManage.vue?vue&type=style&index=0&id=a78134de&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78134de"]])

export default __exports__